import React, { useState, useEffect } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
  CardElement,
} from "@stripe/react-stripe-js";
import { MdLock } from "react-icons/md";
import ReactGA from "react-ga4";

interface props {
  surveyId?: number;
  loadingProfile?: boolean;
  loadingPayment: boolean;
  setLoadingPayment: any;
  paymentConfirmation?: any;
  loadingPaymentConfirmation?: boolean;
  setLoadingPaymentConfirmation?: any;
  clientSecret?: any;
  email?: string;
  setEmail?: any;
  name?: string;
  price?: any;
  setName?: (value: string) => void;
}
const PaymentComponent: React.FC<props> = (props) => {
  const {
    surveyId,
    setLoadingPayment,
    paymentConfirmation,
    loadingPaymentConfirmation,
    setLoadingPaymentConfirmation,
    setEmail,
    email,
    setName,
    name,
    price,
  } = props;
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState<any>("");

  const handlePaymentSubmission = async (e: any) => {
    e.preventDefault();
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    setLoadingPaymentConfirmation(true);
    // const result: any = await stripe.confirmPayment({
    const result: any = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/skincaresteps`,
        // receipt_email: email,
        payment_method_data: {
          billing_details: {
            name: name, // Pass custom name here
            email: email,
          },
        },
      },
      redirect: "if_required",
    });

    console.log("Stripe  payment result", result);
    const { setupIntent, error } = result;

    const paymentMethod = setupIntent?.payment_method;

    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message);
      } else {
        setMessage("An unexpected error occurred.");
      }
      setLoadingPaymentConfirmation(false);
    } else {
      if (setupIntent?.status === "succeeded") {
        paymentConfirmation(e, setupIntent);
      }
    }

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
  };

  const paymentElementOptions: any = {
    layout: "tabs",
  };

  return (
    <form id="payment-form" onSubmit={handlePaymentSubmission}>
      <PaymentElement
        id="payment-element"
        options={paymentElementOptions}
        onReady={(val?: any) => {
          setLoadingPayment(false);
        }}
      />
      <button
        disabled={loadingPaymentConfirmation || !stripe || !elements}
        onClick={() => {
          ReactGA.event({
            category: "Payment",
            action: `Place order button clicked`,
            label: "",
            nonInteraction: true, // optional, true/false
            transport: "xhr",
          });
        }}
        id="submit"
        className="btn-primary"
      >
        <span className="button-text">
          {loadingPaymentConfirmation ? (
            <div className="spinner" id="spinner"></div>
          ) : (
            <>
              <MdLock />
              Pay via Secure Checkout
            </>
          )}
        </span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
};

export default PaymentComponent;
